import React from "react"
import { Router, Route, Switch, Redirect } from "react-router-dom"
// import { Router, Route, Switch, Redirect } from "react-router-dom"
import Home from "./pages/Home"
import {
  Register,
  QRRegister,
  Login,
  PasswordRecovery,
  ResetPassword
} from "./pages/auth"

import Container from "./layout/Container"

import OnboardingStartPage from "./pages/onboarding/OnboardingStartPage"
import ActivateAccountPage from "./pages/onboarding/ActivateAccountPage"

import history from "./HistoryExport"

const Routes = (mainProps) => {
  return (
    <Router history={history}>
      <Container>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/register" render={(props) => React.createElement(Register, { ...props, ...mainProps })} />
          <Route exact path="/qrregister" component={QRRegister} />
          <Route exact path="/login" render={(props) => React.createElement(Login, { ...props, ...mainProps })} />
          <Route exact path="/forgot-password" render={(props) => React.createElement(PasswordRecovery, { ...props, ...mainProps })} />
          <Route exact path="/reset" render={(props) => React.createElement(ResetPassword, { ...props, ...mainProps })} />
          {/* PUBLIC self-serve onboarding. The payment redirect lands on
              /onboarding/self-serve?token=... while logged out; after the
              activation page auto-logs the user in, <Auth> swaps to AuthedRoutes
              where the same path resolves to the authenticated wizard. */}
          <Route exact path="/onboarding/self-serve" render={(props) => React.createElement(OnboardingStartPage, { ...props, ...mainProps })} />
          <Route exact path="/onboarding/activate" render={(props) => React.createElement(ActivateAccountPage, { ...props, ...mainProps })} />
          <Redirect to="/" />
        </Switch>
      </Container>
    </Router>
  )
}

export default Routes;